// ----------------------------------------------------------------------------
// Component: Products Comparison Table
// ----------------------------------------------------------------------------
//
// Section displaying a products comparison table.
//
// ----------------------------------------------------------------------------

// Style includes
import './_compare-products.scss';

const comparisonTables = document.querySelectorAll('.products-comparison-table');

comparisonTables.forEach((section) => {
  const scrollWrapper = section.querySelector('.products-comparison-table__scroll-wrapper');
  const stickyHeader = section.querySelector('.products-comparison-table__sticky-header');
  const bodyTable = section.querySelector('.products-comparison-table__table');
  const stickyTable = section.querySelector('.products-comparison-table__header-table');

  if (!scrollWrapper || !stickyHeader || !bodyTable || !stickyTable) {
    return;
  }

  let isFixed = false;

  const getBodyCells = () => {
    const headCells = bodyTable.querySelectorAll('thead tr:first-child > th, thead tr:first-child > td');
    if (headCells.length) {
      return headCells;
    }
    const firstRow = bodyTable.querySelector('tbody tr');
    if (firstRow) {
      return firstRow.querySelectorAll('th, td');
    }
    return [];
  };

  const syncColumnWidths = () => {
    const bodyCells = getBodyCells();
    const stickyCells = stickyTable.querySelectorAll('thead tr:first-child > th, thead tr:first-child > td');

    if (!bodyCells.length || bodyCells.length !== stickyCells.length) {
      return;
    }

    stickyCells.forEach((cell, index) => {
      const width = bodyCells[index].getBoundingClientRect().width;
      cell.style.width = `${width}px`;
    });
  };

  const syncHorizontal = () => {
    if (!isFixed) {
      stickyTable.style.transform = '';
      return;
    }
    stickyTable.style.transform = `translateX(${-scrollWrapper.scrollLeft}px)`;
  };

  const getHeaderHeight = () => {
    const thead = bodyTable.querySelector('thead');
    if (thead) {
      return thead.getBoundingClientRect().height;
    }
    return stickyHeader.offsetHeight;
  };

  const updateSticky = () => {
    const rect = scrollWrapper.getBoundingClientRect();
    const headerHeight = getHeaderHeight();
    const shouldStick = rect.top <= -headerHeight && rect.bottom > headerHeight;

    if (shouldStick && !isFixed) {
      isFixed = true;
      stickyHeader.classList.add('is-fixed');
    } else if (!shouldStick && isFixed) {
      isFixed = false;
      stickyHeader.classList.remove('is-fixed');
      scrollWrapper.style.paddingTop = '';
      stickyHeader.style.left = '';
      stickyHeader.style.width = '';
      stickyTable.style.width = '';
      stickyTable.style.transform = '';
    }

    if (isFixed) {
      scrollWrapper.style.paddingTop = `${headerHeight}px`;
      stickyHeader.style.left = `${rect.left}px`;
      stickyHeader.style.width = `${rect.width}px`;
      stickyTable.style.width = `${bodyTable.scrollWidth}px`;
      syncColumnWidths();
      syncHorizontal();
    }
  };

  scrollWrapper.addEventListener('scroll', syncHorizontal, { passive: true });
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  window.addEventListener('load', updateSticky);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateSticky);
  }

  let isDragging = false;
  let didDrag = false;
  let startX = 0;
  let startScrollLeft = 0;

  const isInteractiveTarget = (target) => Boolean(target.closest('a, button, input, textarea, select, label'));

  const startDrag = (event) => {
    if (event.button !== 0 || isInteractiveTarget(event.target)) {
      return;
    }

    const rect = scrollWrapper.getBoundingClientRect();
    isDragging = true;
    didDrag = false;
    startX = event.clientX - rect.left;
    startScrollLeft = scrollWrapper.scrollLeft;
    scrollWrapper.classList.add('is-dragging');
  };

  const onDragMove = (event) => {
    if (!isDragging) {
      return;
    }

    event.preventDefault();
    const rect = scrollWrapper.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const walk = x - startX;

    if (Math.abs(walk) > 5) {
      didDrag = true;
    }

    scrollWrapper.scrollLeft = startScrollLeft - walk;
    syncHorizontal();
  };

  const endDrag = () => {
    if (!isDragging) {
      return;
    }

    isDragging = false;
    scrollWrapper.classList.remove('is-dragging');

    if (didDrag) {
      scrollWrapper.classList.add('was-dragged');
      setTimeout(() => scrollWrapper.classList.remove('was-dragged'), 0);
    }
  };

  scrollWrapper.addEventListener('mousedown', startDrag);
  scrollWrapper.addEventListener('mousemove', onDragMove);
  scrollWrapper.addEventListener('mouseleave', endDrag);
  document.addEventListener('mouseup', endDrag);
  scrollWrapper.addEventListener(
    'click',
    (event) => {
      if (scrollWrapper.classList.contains('was-dragged')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  updateSticky();
});
